import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import ApIngestionResultsContainer from '../../containers/apAutomation/ApIngestionResults';
import AuthUserContainer from '../../containers/AuthUser';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import invoiceIcon from '../../images/invoicePdf.svg';
import { renderApIngestionDocs } from './helper';

import PendingIcon from '@material-ui/icons/AccessTime';
import InvalidIcon from '@material-ui/icons/DeleteForever';
import SentIcon from '@material-ui/icons/Send';

//Tabs
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const commonColumns = [
	{
		sortId: 'apIngestionResultId',
		displayId: 'apIngestionResultId',
		label: 'Result ID',
	},
	{
		sortId: 'apIngestionId',
		displayId: 'apIngestionDisplay',
		label: 'Ingestion ID',
	},
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Date Created',
	},
	{
		sortId: 'originalDocumentDisplay',
		displayId: 'originalDocumentDisplay',
		label: 'Uploaded Doc',
	},
	{
		sortId: 'matchResultStatus',
		displayId: 'matchResultStatusDisplay',
		label: 'Data Match Status',
	},
];

const pendingColumns = [
	...commonColumns,
	{
		sortId: 'triage',
		displayId: 'triageButtons',
		label: 'Triage',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];
const billCreatedColumns = [
	...commonColumns,
	{
		sortId: 'mappedToToVendorBillId',
		displayId: 'mappedToToVendorBillDisplay',
		label: 'Bill Created',
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const invalidColumns = [
	...commonColumns,
	{
		sortId: 'invalidReason',
		displayId: 'invalidReason',
		label: 'Reason Invalid',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
	{
		sortId: 'view',
		displayId: 'viewButton',
		label: 'View',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir}>
			{children}
		</Typography>
	);
}

class ApIngestionResults extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'apIngestionResultId',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		};
	}

	componentDidMount() {
		const { apIngestionResults, apIngestionResultSearch } = this.props;

		if (!apIngestionResults) {
			apIngestionResultSearch({});
		} else {
			this.formatApIngestionResults();
		}
	}

	componentDidUpdate(prevProps) {
		const { apIngestionResults } = this.props;
		if (prevProps.apIngestionResults !== apIngestionResults) {
			this.formatApIngestionResults();
		}
	}

	formatApIngestionResults = () => {
		const { classes } = this.props;
		const {
			apIngestionResults,
			apIngestionDocumentMap,
			//apGuideMap,
		} = this.props;
		const invalidRows = [];
		const pendingRows = [];
		const billCreatedRows = [];
		apIngestionResults.forEach((apIngestionResult) => {
			const {
				apIngestionResultId,
				apIngestionId,
				apIngestionDocumentIds,
				dateCreated,
				// matchResult,
				matchResultStatus,
				//matchResultStatusMessage,
				originalIngestionDocumentResourceId,
				mappedToToVendorBillId,
				invalidReason,
				// invalidReason,
				isRackToRackTransfer,
			} = apIngestionResult;

			apIngestionResult.key = apIngestionResultId;
			apIngestionResult.apIngestionDisplay = (
				<div>
					<div>Id: {apIngestionId}</div>
					<div>{moment(dateCreated).format('M/D/YYYY')}</div>
				</div>
			);

			apIngestionResult.dateCreatedFormatted = moment(dateCreated).format('dddd, M/D h:mm a');

			if (matchResultStatus === 'matched') {
				apIngestionResult.matchResultStatusDisplay = (
					<>
						<span className={classes.greenCheckedIconSmall} /> Matched
					</>
				);
			} else if (isRackToRackTransfer) {
				apIngestionResult.matchResultStatusDisplay = (
					<>
						<span className={classes.greenCheckedIconSmall} /> Rack to Rack
					</>
				);
			} else if (matchResultStatus === 'possibleRackToRack') {
				apIngestionResult.matchResultStatusDisplay = (
					<>
						<span className={classes.warningIconSmall} /> {_.startCase(matchResultStatus)}
					</>
				);
			} else if (matchResultStatus === 'partialMatch') {
				apIngestionResult.matchResultStatusDisplay = (
					<>
						<span className={classes.warningIconSmall} /> {_.startCase(matchResultStatus)}
					</>
				);
			} else {
				apIngestionResult.matchResultStatusDisplay = (
					<>
						<div>
							<span className={classes.errorIconSmall} />{' '}
							{_.startCase(matchResultStatus || 'Ingestion Error')}
						</div>
					</>
				);
			}

			apIngestionResult.originalDocumentDisplay = (
				<div
					className={classes.invoiceIcon}
					onClick={() => {
						this.handleDocClick(originalIngestionDocumentResourceId);
					}}
				/>
			);

			if (_.isEmpty(apIngestionDocumentIds)) {
				apIngestionResult.documentsDisplay = '-';
			} else {
				const apIngestionDocuments = apIngestionDocumentIds.map((apIngestionDocumentId) => {
					return apIngestionDocumentMap[apIngestionDocumentId];
				});

				apIngestionResult.documentsDisplay = renderApIngestionDocs({
					apIngestionDocuments,
					ignoreGroups: true,
				});
			}

			apIngestionResult.mappedToToVendorBillDisplay = mappedToToVendorBillId ? (
				<div>
					<div style={{ fontSize: 13 }}>
						<span style={{ color: 'green', display: 'inline-block', width: '15px' }}>✓</span>
						mapped
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
						}}
					>
						Vendor Bill #<strong>{mappedToToVendorBillId}</strong>
						<a
							href={`/billing/vendorBill/update/${mappedToToVendorBillId}`}
							style={{ textDecoration: 'none', paddingLeft: 5, height: 17 }}
							target="_blank"
							rel="noreferrer noopener"
						>
							<OpenLink style={{ width: 16, height: 16 }} />
						</a>
					</div>
				</div>
			) : (
				'-'
			);

			apIngestionResult.triageButtons = (
				<>
					<Button className={classes.button} onClick={() => this.handleTriage(apIngestionResultId)}>
						Triage
					</Button>
				</>
			);

			apIngestionResult.viewButton = (
				<>
					<Button className={classes.button} onClick={() => this.handleTriage(apIngestionResultId)}>
						View
					</Button>
				</>
			);

			if (invalidReason) {
				invalidRows.push(apIngestionResult);
			} else if (mappedToToVendorBillId) {
				billCreatedRows.push(apIngestionResult);
			} else {
				pendingRows.push(apIngestionResult);
			}
			//formattedApIngestionResults.push(apIngestionResult);
		});
		this.setState({ invalidRows, billCreatedRows, pendingRows });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleTriage = (apIngestionResultId) => {
		this.props.history.push(`/apAutomation/apIngestionResult/triage/${apIngestionResultId}`);
	};

	handleDocClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	handleChangeTabIndex = (index) => {
		this.setState({ tabIndex: index });
	};

	render() {
		const { classes, resourceMap, theme } = this.props;
		const { pendingRows, billCreatedRows, invalidRows, order, orderBy } = this.state;

		if (!pendingRows) {
			return <div>Loading the ap ingestions...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>AP Ingestion Result Triage</span>
							</Typography>
						</Grid>
					</Grid>

					<AppBar position="static" color="default">
						<Tabs
							value={this.state.tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Pending Triage" icon={<PendingIcon />} />
							<Tab label="Bill Created" icon={<SentIcon />} />
							<Tab label="Invalid / Skipped" icon={<InvalidIcon />} />
						</Tabs>
					</AppBar>
					<Paper className={classes.paper}>
						<SwipeableViews
							axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
							index={this.state.tabIndex}
							onChangeIndex={this.handleChangeTabIndex}
						>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={pendingColumns}
									rows={pendingRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={billCreatedColumns}
									rows={billCreatedRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
							<TabContainer dir={theme.direction}>
								<EnhancedTable
									columns={invalidColumns}
									rows={invalidRows}
									defaultOrder={order}
									defaultOrderBy={orderBy}
								/>
							</TabContainer>
						</SwipeableViews>

						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

ApIngestionResults.propTypes = {
	classes: PropTypes.object.isRequired,
	apIngestionResultSearch: PropTypes.func.isRequired,
	apIngestionResults: PropTypes.array,

	showErrors: PropTypes.func.isRequired,

	apIngestionDocumentMap: PropTypes.object,
	carrierMap: PropTypes.object,
	supplierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	resourceMap: PropTypes.object,
	stationInvoiceMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	stationMap: PropTypes.object,
	apGuideMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,

	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	ApIngestionResultsContainer,
])(ApIngestionResults);
